// Imports
import React from "react";
import PropTypes from "prop-types";

const ValidationTooltip = ({ message = "Please fill out this field.", style = {} }) => {
  if (!message) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: "calc(100% - 2px)",
        left: 12,
        zIndex: 1200,
        backgroundColor: "#ffffff",
        color: "#202124",
        padding: "6px 12px 6px 8px",
        borderRadius: 4,
        boxShadow: "0 2px 10px rgba(0,0,0,0.18), 0 0 1px rgba(0,0,0,0.3)",
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 13,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        border: "1px solid #dadce0",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: 1.4,
        ...style,
      }}
    >
      {/* Outer Arrow Border */}
      <div
        style={{
          position: "absolute",
          top: -7,
          left: 16,
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderBottom: "6px solid #dadce0",
        }}
      />
      {/* Inner Arrow Fill */}
      <div
        style={{
          position: "absolute",
          top: -6,
          left: 16,
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderBottom: "6px solid #ffffff",
        }}
      />
      {/* Exclamation Icon */}
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: 3,
          backgroundColor: "#f25624",
          color: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: "bold",
          flexShrink: 0,
        }}
      >
        !
      </div>
      <span>{message}</span>
    </div>
  );
};

ValidationTooltip.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object,
};

export default ValidationTooltip;
